import script from "./single-property-1.vue?vue&type=script&setup=true&lang=js"
export * from "./single-property-1.vue?vue&type=script&setup=true&lang=js"

import "./single-property-1.vue?vue&type=style&index=0&id=08ba9023&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ba9023"]])

export default __exports__